import React, { useState } from "react";
import { styled } from "@mui/material/styles";

import { Tooltip } from "@mui/material";

interface TooltipTextProps {
  text: string;
  maxLines?: number;
}

export const TooltipText: React.FC<TooltipTextProps> = ({
  text,
  maxLines = 1
}): JSX.Element => {
  const [isTruncated, setIsTruncated] = useState(false);

  const handleMouseOver = (
    event: React.MouseEvent<HTMLHeadingElement>
  ): void => {
    setIsTruncated(
      event.currentTarget.textContent
        ? event.currentTarget.scrollHeight > event.currentTarget.clientHeight
        : false
    );
  };

  const cellContent = (
    <TextContent maxLines={maxLines} onMouseOver={handleMouseOver}>
      {text}
    </TextContent>
  );

  return (
    <>
      <Tooltip title={isTruncated ? text : ""} enterDelay={500}>
        {cellContent}
      </Tooltip>
    </>
  );
};

interface TextContentProps {
  maxLines?: number;
}

const TextContent = styled("div")<TextContentProps>`
  display: -webkit-box;
  -webkit-line-clamp: ${props => props.maxLines || 1};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
